import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\VoucherDetailInertiaController::show
* @see app/Http/Controllers/VoucherDetailInertiaController.php:27
* @route '/uu-dai/{code}'
*/
export const show = (args: { code: string | number } | [code: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/uu-dai/{code}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\VoucherDetailInertiaController::show
* @see app/Http/Controllers/VoucherDetailInertiaController.php:27
* @route '/uu-dai/{code}'
*/
show.url = (args: { code: string | number } | [code: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { code: args }
    }

    if (Array.isArray(args)) {
        args = {
            code: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        code: args.code,
    }

    return show.definition.url
            .replace('{code}', parsedArgs.code.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\VoucherDetailInertiaController::show
* @see app/Http/Controllers/VoucherDetailInertiaController.php:27
* @route '/uu-dai/{code}'
*/
show.get = (args: { code: string | number } | [code: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VoucherDetailInertiaController::show
* @see app/Http/Controllers/VoucherDetailInertiaController.php:27
* @route '/uu-dai/{code}'
*/
show.head = (args: { code: string | number } | [code: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\VoucherDetailInertiaController::show
* @see app/Http/Controllers/VoucherDetailInertiaController.php:27
* @route '/uu-dai/{code}'
*/
const showForm = (args: { code: string | number } | [code: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VoucherDetailInertiaController::show
* @see app/Http/Controllers/VoucherDetailInertiaController.php:27
* @route '/uu-dai/{code}'
*/
showForm.get = (args: { code: string | number } | [code: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VoucherDetailInertiaController::show
* @see app/Http/Controllers/VoucherDetailInertiaController.php:27
* @route '/uu-dai/{code}'
*/
showForm.head = (args: { code: string | number } | [code: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

const VoucherDetailInertiaController = { show }

export default VoucherDetailInertiaController